__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "aleph-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@googlemaps/polyline-codec", "1.0.28", () => (() => (__webpack_require__(81227))), 1);
			register("@urbica/react-map-gl", "1.16.2", () => (() => (__webpack_require__(24480))), 1);
			register("mapbox-gl", "^2.15.0", () => (() => (__webpack_require__(3692))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(52407))), 1);
			register("react-intl", "6.4.4", () => (() => (__webpack_require__(67199))), 1);
			register("react-relay", "15.0.0", () => (() => (__webpack_require__(3606))), 1);
			register("react-router-dom", "6.12.1", () => (() => (__webpack_require__(98322))), 1);
			register("react-spring", "9.7.5", () => (() => (__webpack_require__(63625))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(76998))), 1);
			initExternal(92518);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};